import { AscendError, CommonSystemError } from "../../error";
import { isNotEmptyString, isNumber, isString } from "../../type-guards";
export class NumberString {
    v;
    constructor(v) {
        NumberString.assert(v);
        this.v = NumberString.parse(v);
    }
    toValue() {
        return this.v;
    }
    toNumber() {
        return Number(this.v);
    }
    static assert(v) {
        if (isNumber(v)) {
            return;
        }
        if (isString(v) && /[\d.-]/.test(v) && !isNaN(Number(v))) {
            return;
        }
        throw new CommonSystemError.AssertionFailure(`value is not string number ${v}`);
    }
    static parse(v) {
        if (isString(v)) {
            return v.at(0) === "." ? `0${v}` : v;
        }
        try {
            this.assert(v);
        }
        catch (e) {
            return AscendError.isAscendError(e) ? e : e;
        }
        return Number(v).toString();
    }
    static isParsable(v) {
        return isNotEmptyString(v) || isNumber(v);
    }
}
//# sourceMappingURL=number-string.js.map